/** Location saved on document links so the detail page can return to its source. */
export interface PrpDocumentOrigin {
  pathname: string;
  search: string;
  label: string;
}

const LIST_LABELS: Record<string, string> = {
  '/prp': 'Dashboard',
  '/prp/caseload': 'Caseload',
  '/prp/documents': 'Documents',
  '/prp/contact-notes': 'Contact Notes',
  '/prp/referrals': 'Referrals',
  '/prp/authorizations': 'Authorizations',
  '/prp/irps': 'IRPs',
  '/prp/dla20': 'DLA-20',
  '/prp/monthly-summaries': 'Monthly Summaries',
  '/prp/reviews': 'Pending Sign-offs',
};

export function documentOrigin(
  pathname: string,
  search = '',
): { prpDocumentOrigin: PrpDocumentOrigin } {
  return {
    prpDocumentOrigin: {
      pathname,
      search,
      label: pathname.startsWith('/prp/clients/')
        ? 'Client chart'
        : pathname.startsWith('/prp/intakes/')
          ? 'Referral intake'
          : pathname.startsWith('/prp/documents/')
            ? 'Document'
            : (LIST_LABELS[pathname] ?? 'PRP workspace'),
    },
  };
}

export function clientOrigin(
  pathname: string,
  search = '',
): { prpClientOrigin: PrpDocumentOrigin } {
  return { prpClientOrigin: documentOrigin(pathname, search).prpDocumentOrigin };
}

function readOrigin(
  state: unknown,
  key: 'prpDocumentOrigin' | 'prpClientOrigin',
): PrpDocumentOrigin | null {
  if (!state || typeof state !== 'object' || !(key in state)) return null;
  const origin = (state as Record<string, unknown>)[key];
  if (!origin || typeof origin !== 'object') return null;
  if (!('pathname' in origin) || typeof origin.pathname !== 'string') return null;
  if (!('search' in origin) || typeof origin.search !== 'string') return null;
  if (!('label' in origin) || typeof origin.label !== 'string') return null;
  if (origin.pathname !== '/prp' && !origin.pathname.startsWith('/prp/')) return null;
  return origin as PrpDocumentOrigin;
}

export function readDocumentOrigin(state: unknown): PrpDocumentOrigin | null {
  const origin = readOrigin(state, 'prpDocumentOrigin');
  return origin?.pathname.startsWith('/prp/documents/') ? null : origin;
}

export function readClientOrigin(state: unknown): PrpDocumentOrigin | null {
  return readOrigin(state, 'prpClientOrigin');
}
